export default function AboutHero() {
  return (
    <section className="relative bg-[#FAF8F5] pt-36 pb-0 px-8 md:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-end">
          {/* Left: Text */}
          <div className="pb-16">
            <p className="text-[#C9A961] tracking-[0.3em] text-xs uppercase font-light mb-6">
              About Table Privé
            </p>
            <h1 className="font-serif text-[#1A1A1A] text-5xl md:text-6xl lg:text-7xl font-normal leading-[1.1] mb-8">
              Refined hospitality<br />
              built on <em className="italic text-[#8A7F74]">atmosphere</em><br />
              and intention.
            </h1>
            <p className="text-[#8A7F74] text-base font-light leading-relaxed max-w-md">
              Table Privé was born from a belief that the finest moments in life deserve an equally extraordinary setting. We are not a catering company. We are experience architects.
            </p>
          </div>

          {/* Right: Hero image */}
          <div className="relative">
            <div className="overflow-hidden rounded-t-lg" style={{ aspectRatio: "4/5" }}>
              <img
                src="https://public.readdy.ai/ai/img_res/f64c032099f32e6ba71b728f9bfdeef2.jpg"
                alt="Table Privé — refined private dining"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#FAF8F5]/30 via-transparent to-transparent" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
